export default __webpack_public_path__ + "static/media/personal-loan-costs.6c4c7dad.svg";